import { createDrawerNavigator } from "@react-navigation/drawer";
import { observer } from "mobx-react";
import React from "react";
import SideDrawer from "../components/SideDrawer";
import SearchDocuments from "../screens/document/SearchDocuments";
import AddModerators from "../screens/drawer/AddModerators";
import Home from "../screens/drawer/Home";
import SuspendedUsers from "../screens/drawer/SuspendedUsers";
import Verification from "../screens/drawer/Verification";

const Drawer = createDrawerNavigator();

const DashboardNavigator = observer(() => {
  return (
    <Drawer.Navigator drawerContent={(props) => <SideDrawer {...props} />}>
      <Drawer.Screen name="home" component={Home} />
      <Drawer.Screen name="searchdocuments" component={SearchDocuments} />
      <Drawer.Screen name="verification" component={Verification} />
      <Drawer.Screen name="suspendedusers" component={SuspendedUsers} />
      <Drawer.Screen name="addmoderators" component={AddModerators} />
    </Drawer.Navigator>
  );
});

export default DashboardNavigator;
